import get from "lodash/get";
import request from "superagent";
import { push } from "react-router-redux";
import Raven from "raven-js";
import { clanCost } from "helpers/clan";
import { ATTRIBUTES_VALIDATION_STATE } from "fe2/Components/UIKit/ClanCreate/Constants";
import settings from "settings";
import { delay } from "helpers/delay";
import { fetchWrapper as fetch, fetchWithSpinner } from "helpers/fetch";
import { t } from "helpers/localization";
import { trimAndRemoveSpaces } from "helpers/strings";
import * as web2ClientAPI from "web2ClientAPI/web2ClientAPI";
import { updateAccountInfo, decreaseAccountTotalGold, syncAccountInfo } from "./ActionAccount";

const CLAN_CREATE_WAIT_DELAY = 500;


export const ERROR_CREATION_CLAN = 'ERROR_CREATION_CLAN';
export const FINISH_CHECK_AVAILABILITY_CLAN_CREATION = 'FINISH_CHECK_AVAILABILITY_CLAN_CREATION';
export const SET_INITIAL_STATE_CREATION_CLAN = 'SET_INITIAL_STATE_CREATION_CLAN';
export const START_CHECK_AVAILABILITY_CLAN_CREATION = 'START_CHECK_AVAILABILITY_CLAN_CREATION';
export const START_CREATION_CLAN = 'START_CREATION_CLAN';
export const UPDATE_CREATION_CLAN_FIELD_VALUE = 'UPDATE_CREATION_CLAN_FIELD_VALUE';

export const startCreationClan = () => {
  return {
    type: START_CREATION_CLAN
  };
};

export const errorCreationClan = error => {
  return {
    type: ERROR_CREATION_CLAN,
    error
  };
};

export const updateFieldValueCreationClan = (field, value, error) => {
  return {
    type: UPDATE_CREATION_CLAN_FIELD_VALUE,
    field,
    value,
    error
  };
};

export const startCheckAvailabilityCreationClan = field => {
  return {
    type: START_CHECK_AVAILABILITY_CLAN_CREATION,
    field
  };
};

export const finishCheckAvailabilityCreationClan = data => {
  return {
    type: FINISH_CHECK_AVAILABILITY_CLAN_CREATION,
    data
  };
};

export const setInitialStateCreationClan = () => {
  return {
    type: SET_INITIAL_STATE_CREATION_CLAN
  };
};

export const checkNameOrTagAvailability = (field, value, finishAction) => {
  return (dispatch, getState) => {
    const state = getState();
    const req = request.post(state.urls.checkClanNameTagAvability);

    req.type('application/json; charset=UTF-8').accept('application/json').set({
      'X-CSRFToken': settings.csrfToken,
      'X-Requested-With': 'XMLHttpRequest'
    }).withCredentials().send({ [field]: value }).then(response => {
      let error = null;
      const json = response.body;
      const data = json.current[field];
      if (!data.available) {
        const defaultError = {
          tag: t('Клан с таким тегом уже зарегистрирован.'),
          name: t('Клан с таким названием уже зарегистрирован')
        };
        error = data.reason || defaultError[field];
      }

      const available = data.available ? ATTRIBUTES_VALIDATION_STATE.AVAILABLE : ATTRIBUTES_VALIDATION_STATE.NOT_AVAILABLE;
      const clippedValue = trimAndRemoveSpaces(value);
      dispatch(finishAction({
        field,
        value: clippedValue,
        available,
        error
      }));
    }, () => {
      dispatch(finishAction({
        field,
        value,
        available: ATTRIBUTES_VALIDATION_STATE.UNDEFINED,
        error: t('Не удалось проверить: техническая ошибка')
      }));
    });
    return req;
  };
};

export const checkCreationClanStatus = (dispatch, json, state, forceCheck) => {
  const status = json.status || get(json, 'clan.status');
  if (['creating', 'payment_requested'].includes(status)) {
    const promise = forceCheck ? fetch(state.urls.clanCheckStatus) : delay(CLAN_CREATE_WAIT_DELAY).then(() => fetch(state.urls.clanCheckStatus));

    return promise.then(json => checkCreationClanStatus(dispatch, json, state));
  } else {
    if (status === 'active') {
      const clan = get(json, 'clan');
      const cost = clanCost();
      web2ClientAPI.sendClanCreationNotification(clan, cost);
      dispatch(updateAccountInfo({
        clanId: get(json, 'clan.id'),
        role: 'commander',
        activeInvitesCount: 0
      }));
      dispatch(decreaseAccountTotalGold(cost));
      dispatch(setInitialStateCreationClan());

      const root = state.urls.root;
      dispatch(push(`${root}profile`));
    } else if (status === 'payment_rejected') {
      web2ClientAPI.sendClanCreationNotEnoughGoldNotification();
      dispatch(errorCreationClan(json));
    } else if (status === 'error') {
      web2ClientAPI.sendClanCreationErrorNotification();
      dispatch(errorCreationClan(json));
    } else {
      /* eslint-disable no-console */
      const msg = `Undefined behavior for clan status: ${status}`;
      console.error(msg);
      if (settings.sentryUrl) {
        Raven.captureMessage(msg, { extra: json });
      }
      dispatch(errorCreationClan());
    }
  }
};

const forceSyncAccountInfo = (dispatch, json, root) => {
  return dispatch(syncAccountInfo()).then(() => {
    dispatch(setInitialStateCreationClan());
    web2ClientAPI.sendClanCreationAlreadyInClanNotification();
  }, () => {
    web2ClientAPI.sendClanCreationAlreadyInClanNotification();
    const clanId = get(json, 'additional_info.clan_id', null);
    if (clanId) {
      dispatch(updateAccountInfo({
        clanId,
        role: 'private',
        activeInvitesCount: 0
      }));
    }
    dispatch(setInitialStateCreationClan());
    dispatch(push(`${root}profile`));
  });
};

export const creationClan = () => {
  return (dispatch, getState) => {
    /* eslint-disable no-console */
    const state = getState();
    if (state.clanCreate.isProcessing) {
      const msg = 'Clan in creation process';
      console.error(msg);
      if (settings.sentryUrl) {
        Raven.captureMessage(msg, { extra: state.clanCreate });
      }
      return {};
    }

    const {
      tag,
      name
    } = state.clanCreate;
    const availableState = ATTRIBUTES_VALIDATION_STATE.AVAILABLE;
    if (tag.available !== availableState || name.available !== availableState) {
      console.error('Tag or name is not available');
      return {};
    }

    dispatch(startCreationClan());

    const url = state.urls.clanCreate;
    const body = {
      tag: tag.value,
      name: name.value
    };
    const promise = fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: body
    }).then(json => {
      if (json.errors || json.additional_info || json.status === 'error') {
        if (get(json, 'additional_info.reason') === 'account_already_in_clan') {
          return forceSyncAccountInfo(dispatch, json, state.urls.root);
        } else if (json.errors && (json.errors.name || json.errors.tag)) {
          web2ClientAPI.sendClanCreationTagOrNameNotAvailableNotification();
          dispatch(errorCreationClan(json));
        } else {
          web2ClientAPI.sendClanCreationErrorNotification();
          dispatch(errorCreationClan(json));
        }
      } else if (json.status === 'redirect') {
        dispatch(errorCreationClan(json));
      } else {
        return checkCreationClanStatus(dispatch, json, state);
      }
    }).catch(() => {
      web2ClientAPI.sendClanCreationErrorNotification();
      dispatch(errorCreationClan({ error: t('Произошла ошибка. Повторите попытку позже') }));
    });

    return fetchWithSpinner(dispatch, promise, t('Создаём клан'));
  };
};

export const waitForClanCreation = () => {
  return (dispatch, getState) => {
    const status = getState().currentAccount.clanStatus;
    if (status && ['creating', 'payment_requested'].includes(status)) {
      return fetchWithSpinner(dispatch, checkCreationClanStatus(dispatch, { status }, getState(), true), t('Создаём клан')).catch(() => web2ClientAPI.sendClanCreationErrorNotification());
    }
  };
};